import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';
import handled from '../../../assets/svg/check.svg'

import PatientNotesPreview from '../../../components/patientNotesPreview';


import moment from 'moment';
import { API_ENDPOINT } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';
import { showStatusHistoryButton } from '../../../helpers/referral-statuses';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';
import UserIsNotVerifiedTooltip from '../../../components/UserIsNotVerifiedTooltip';

import ErrorModalV2 from '../../../components/errorModal_v2';


import striptags from 'striptags';
import InfoModal from '../../../components/infoModal';

import FormPreview from '../../forms/previewAnsweredForm';
import ReferralContent from '../../../components/referralContent';
import { addMinutesToTime, generateSections } from '../helper';
import RecurringDescription from '../../referral/RecurringDescription';
import EventPreviewPaymentField from '../../payments/components/eventPreviewPaymentField';
import VisitCancellation from '../../payments/components/visitCancellation';
import WebDocInfo from '../components/webDocInfo';
import { checkIsJournalEnabled } from '../../../helpers/journal.helper';


function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class UpdateEvent extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            doctors: [],
            minTime: '07:00',
            maxTime: '18:00',
            minTransferDoctor: '07:00',
            maxTransferDoctor: '18:00',
            meetingParticipantsList: [],
        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)
    }
    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }
    getTransferWorkingHours = (doctorId, callback) => {
        if (!doctorId) return;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTransferDoctor) {
                setObj.minTransferDoctor = minTime;
            }
            if (maxTime !== this.state.maxTransferDoctor) {
                setObj.maxTransferDoctor = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj, () => {
                    if (callback) {
                        callback();
                    }
                })
            }

        })
    }

    stopAnimation = () => {
        this.player.current.play();
    };
    getPossibleMeetingParticipantsList = (callback) => {
        try {
            const clinicId = this.props.selectedClinic;

            this.setState({ meetingParticipantsList: [] }, () => {
                fetch(API_ENDPOINT + `/meetings/calendar/colleagues/${clinicId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {
                    if (result?.users) {
                        this.setState({ meetingParticipantsList: result.users }, () => {
                            callback?.(this.state.meetingParticipantsList);
                        });
                    }
                })
            })
        } catch (err) { }
    }


    setInitialData = () => {
        this.getDoctors();
        this.getReferralPreviewData();
        this.getPossibleMeetingParticipantsList();
        // this.fetchWebBookingForms();
        // this.getClinicians();
    }
    getReferralPreviewData = () => {
        if (!this.state.data) return;
        this.setState({ previewReferral: null }, async () => {
            let data = JSON.parse(JSON.stringify(this.state.data));
            const eventId = data?._id ?? data?.id ?? null;
            if (eventId && (data.type === 'revisit' || data.type === 'referral')) {
                const response = await fetch(API_ENDPOINT + '/data/referral-from-event/' + eventId,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        }
                    });
                if (response && response.ok) {
                    const result = await response.json();
                    if (result && typeof result === 'object') {
                        if (result && result._2fa) data._2fa = true;
                        this.setState({
                            previewReferral: { ...result, event: data }
                        });
                    }
                }
            }
        })
    }
    getDoctors = () => {
        let query = {
            entries: 10,
            page: 0,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            doctor: this.state.doctorId,
            filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '',
            // day: this.state.day ? this.state.day : new Date(),
            // view: this.state.view
        };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }
    // getClinicians = () => {
    //     const clinicId = this.props.selectedClinic;
    //     if (!clinicId) return;

    //     this.setState({ clinicians: [] }, () => {
    //         fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
    //                 'content-type': 'application/json'
    //             }
    //         }).then(parseJSON).then(({ result, status }) => {
    //             if (result?.clinicians?.length) {
    //                 this.setState({ clinicians: result.clinicians }, () => {
    //                     if (!this.state.doctorId && this.props.doctorId && this.state.clinicians?.find(el => el._id === this.props.doctorId)) {
    //                         this.setState({ doctorId: this.props.doctorId });
    //                     }
    //                 });
    //             }
    //         })
    //     });
    // }


    // fetchWebBookingForms = () => {
    //     if (this.state.data?.doctor) {
    //         this.setState({ webBookingForms: [] }, () => {
    //             fetch(API_ENDPOINT + '/working-hours/web-booking-forms', {
    //                 method: 'POST',
    //                 headers: {
    //                     'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
    //                     'content-type': 'application/json'
    //                 },
    //                 body: JSON.stringify({
    //                     doctor: this.state.data?.doctor,
    //                     group: this.props.selectedGroup,
    //                     clinic: this.props.selectedClinic
    //                 })
    //             }).then(parseJSON).then(({ result, status }) => {
    //                 if (result?.length) {
    //                     this.setState({ webBookingForms: result })
    //                 }
    //             })
    //         })
    //     }


    // }




    componentDidMount() {

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            let doctorId = data.doctor ?? null;;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            this.setState({ data: data, doctorId, doctorsList: data?.additionalDoctors?.length ? data.additionalDoctors : [] }, () => {
                this.getWorkingHours();
                this.setState({ _data: JSON.parse(JSON.stringify(data)) })
                this.setInitialData();
                this.checkWaitingRoomInitialize();
            })
        }

        this.socketInitialize();



    }
    checkWaitingRoomInitialize = () => {
        if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)
        this.checkWaitingRoom()
        this.waitingRoomInterval = setInterval(() => {
            this.checkWaitingRoom()
        }, 5000);

    }
    componentDidUpdate(prevProps, prevState) {

        const { data } = this.state;

        if (JSON.stringify(prevState.data) !== JSON.stringify(data)) {
            this.checkPatientNotes();
        }

    }
    onActiveVideoCalls = (data) => {
        let foundVideoCall = false;
        if (data.myVideoCallsDisconnected && Object.keys(data.myVideoCallsDisconnected).length > 0) {
            this.setState({
                offerData: { ...data.myVideoCallsDisconnected }
            })
        }


        foundVideoCall = true;

        if (!foundVideoCall) {
            this.setState({
                offerData: null
            })
        }

    }
    componentWillUnmount() {
        if (this.props.socket) {
            this.props.socket.removeListener('isPatientInWaitingRoom');
            this.props.socket.removeListener('activeVideoCalls', this.onActiveVideoCalls);
            this.props.socket.removeListener('endCall');
        }
        if (this.socketInterval) clearInterval(this.socketInterval)
        if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)


    }
    registerEvents = async () => {

        this.props.socket?.on('isPatientInWaitingRoom', (data) => {
            if (data?.patientId) {
                let waitingRoom = {
                    patientId: data.patientId,
                    patientInWaitingRoom: data.patientInWaitingRoom,
                    patientHasActiveVideoCall: data.activeCall,
                    showInfoWaitingRoom: !data.activeCall && data.patientInWaitingRoom
                }
                this.setState({ waitingRoom })
            } else {
                if (this.state.waitingRoom) {
                    this.setState({ waitingRoom: null })
                }
            }

        })

        this.props.socket.on('endCall', async (data) => {
            this.setState({
                offerData: null
            })

        });

        this.props.socket.on('activeVideoCalls', (data) => this.onActiveVideoCalls(data));

    }
    checkWaitingRoom = () => {
        if (!this.props.socket || !this.state.data) return;

        if (this.state.data?.patientProfile?._id) {

            let patientId = this.state.data?.patientProfile?._id;
            let data = {
                patientId: patientId,
                groupId: this.props.selectedGroup
            }
            this.props.socket.emit('isPatientInWaitingRoom', data);

        } else {
            if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)
            if (this.state.waitingRoom) {
                this.setState({ waitingRoom: null })
            }
        }


    }
    socketInitialize = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();


            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }

            }, 150);
        }
    }

    toggle = (fetchItems = false) => {
        if (this.props.toggle) {
            this.props.toggle(fetchItems);
        }
    }
    close = () => {
        if (this.state.data && this.state._data) {
            if (JSON.stringify(this.state.data) != JSON.stringify(this.state._data)) {
                this.setState({
                    changesNotSaved: true
                })
            } else {
                this.toggle();
            }
        } else {
            this.toggle();
        }
    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }
    checkRecurring = (data) => {
        let obj = { ...data }
        let recurringObj = {};
        if (obj.frequencyType) {
            recurringObj.frequencyType = obj.frequencyType;
            delete obj.frequencyType;
        }
        if (obj.frequencyDayText) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayText = obj.frequencyDayText;
            delete obj.frequencyDayText;
        }
        if (obj.frequencyMonthScheduled) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduled = obj.frequencyMonthScheduled;
            delete obj.frequencyMonthScheduled;
        }
        if (obj.frequencyDayScheduledDateFrom) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateFrom = obj.frequencyDayScheduledDateFrom;
            delete obj.frequencyDayScheduledDateFrom;
        }
        if (obj.frequencyDayScheduledDateTo) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateTo = obj.frequencyDayScheduledDateTo;
            delete obj.frequencyDayScheduledDateTo;
        }
        if (obj.frequencyMonthScheduledDateFrom) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateFrom = obj.frequencyMonthScheduledDateFrom;
            delete obj.frequencyMonthScheduledDateFrom;
        }
        if (obj.frequencyMonthScheduledDateTo) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateTo = obj.frequencyMonthScheduledDateTo;
            delete obj.frequencyMonthScheduledDateTo;
        }
        if (obj.frequencyWeekScheduledDateFrom) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateFrom = obj.frequencyWeekScheduledDateFrom;
            delete obj.frequencyWeekScheduledDateFrom;
        }
        if (obj.frequencyWeekScheduledDateTo) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateTo = obj.frequencyWeekScheduledDateTo;
            delete obj.frequencyWeekScheduledDateTo;
        }
        if (obj.checkedMonday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedMonday = obj.checkedMonday; delete obj.checkedMonday; }
        if (obj.checkedTuesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedTuesday = obj.checkedTuesday; delete obj.checkedTuesday; }
        if (obj.checkedWednesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedWednesday = obj.checkedWednesday; delete obj.checkedWednesday; }
        if (obj.checkedThursday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedThursday = obj.checkedThursday; delete obj.checkedThursday; }
        if (obj.checkedFriday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedFriday = obj.checkedFriday; delete obj.checkedFriday; }
        if (obj.checkedSaturday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSaturday = obj.checkedSaturday; delete obj.checkedSaturday; }
        if (obj.checkedSunday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSunday = obj.checkedSunday; delete obj.checkedSunday; }

        obj.recurringObj = recurringObj;
        return obj;
    }

    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }
    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event = this.state.data;
        const eventId = event?._id ?? event?.id ?? null;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: eventId
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {
                        let data = this.state.data;
                        data.additionalDoctors = this.state.doctorsList;
                        this.setState({ data })
                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }



    leaveMeeting = (eventId, colleagueId, leaveAllRecurringEvents = false) => {
        if (!eventId || !colleagueId) return;

        let data = {
            eventId,
            colleagueId,
            leaveAllRecurringEvents: leaveAllRecurringEvents ?? false
        }

        this.setState({ loadingLeaveMeeting: true }, () => {
            fetch(API_ENDPOINT + '/working-hours/event/leave-meeting', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                let setObj = { loadingLeaveMeeting: false, deleteColleagueEventModal: null };
                if (result?.error) {
                    setObj.error = result.error?.translate(this.props.lang);
                } else {
                    this.toggle(true);
                }
                this.setState(setObj)

            })
        })

    }
    openConversation = (item) => {
        const eventId = item?._id ?? item?.id ?? null;
        if (eventId) {
            fetch(API_ENDPOINT + '/working-hours/get-referral/' + eventId + '?openConversation=true', {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {
                    if (result.conversations && result.conversations.length) {
                        this.props[0].history.push(`/chat?conversation=${result.conversations[0]._id}`)
                    } else {
                        this.setState({
                            conversationForm: { name: result.patient.referralNumber + '-' + pad(result.conversations.length + 1, 2) }
                        }, () => {
                            this.conversation(result._id, { ...this.state.conversationForm, patient: true });

                        })
                    }


                }

            })

        }
    }
    conversation = (id, data, startCall = false) => {
        this.setState({
            loadingConversation: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/conversation/recpient/' + id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (startCall) {
                    this.props.startVideoCall(result.conversation)
                } else {
                    this.props[0].history.push(`/chat?conversation=${result.conversation}`)

                }

            })

        })
    }
    answerCall = async (data) => {
        this.tryOpenApp(data)

        if (!data?.initiator || !data?.conversation) return;

        if (typeof window === 'undefined') return;

        const initiator = data.initiator;
        const conversationId = data.conversation;


        var strWindowFeatures = `height=${window.innerHeight - 1},width=${window.innerWidth - 1},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`;
        let link = `/video-call/${conversationId}?initiator=${initiator}`;
        this.videoCallWindow = window.open(link, "_blank", strWindowFeatures);


        if (this.videoCallWindow) {
            this.videoCallWindow?.addEventListener?.('message',
                (e) => {
                    if (e?.data == 'end-video-call') {
                        this.videoCallWindow?.close?.();
                    }

                }
                , false)
        }
    }

    tryOpenApp = (data) => {
        const uid = this.props.uData?._id;
        let bundleId;
        const conversationId = data?.conversation;
        const initiator = data?.initiator;
        if (conversationId) {
            fetch(API_ENDPOINT + '/clinic-groups/check/bundleId', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ cid: conversationId })
            }).then(res => res.json()).then((result) => {
                if (result.bundleId) {
                    bundleId = result.bundleId;
                    if (bundleId && conversationId && initiator && uid) {
                        if (bundleId) {
                            try {
                                window.location.replace(`${bundleId}://?conversation=${conversationId}&initiator=${initiator}&uid=${uid}`);
                            } catch (err) { console.log(err) }
                        }
                    }
                }
            });
        }
    }
    startVideoCall = (item) => {
        const eventId = item?._id ?? item?.id ?? null;

        if (eventId) {
            fetch(API_ENDPOINT + '/working-hours/get-referral/' + eventId, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {
                    if (result.conversations && result.conversations.length) {
                        this.props.startVideoCall(result.conversations[0]._id)
                    } else {
                        this.setState({
                            conversationForm: { name: result.patient.referralNumber + '-' + pad(result.conversations.length + 1, 2) }
                        }, () => {
                            this.conversation(result._id, { ...this.state.conversationForm, patient: true }, true);

                        })
                    }


                }

            })

        }
    }
    deleteEventTypeEvent = (eventId, deleteAllRecurringEvents = false) => {
        if (!eventId) return;

        let data = {
            eventId,
            deleteAllRecurringEvents: deleteAllRecurringEvents ?? false
        }

        this.setState({ loadingDelete: true }, () => {
            fetch(API_ENDPOINT + '/working-hours/event/delete', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                let setObj = { loadingDelete: false, deleteEventModal: null };
                if (result?.error) {
                    setObj.error = result.error?.translate(this.props.lang);
                } else {
                    this.toggle(true);
                }
                this.setState(setObj)

            })
        })

    }
    deleteEvent = (data) => {
        const eventId = data?._id ?? data?.id ?? null;
        if (!eventId) return;
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/working-hours/delete/' + eventId, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    title: data.title,
                    doctor: this.state.doctorId
                })
            }).then(res => res.json()).then((result) => {
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        loading: false
                    })
                    this.toggle(true);
                }

            })
        })
    }
    updateEventTypeEvent = (data, updateAllRecurringEvents = false, forceUpdate = false) => {
        const eventId = data?._id ?? data?.id ?? null;
        const doctorId = this.state.doctorId ?? data?.doctor ?? null;

        if (!eventId || !doctorId) {
            this.setState({
                creatingEvent: false
            })
            this.toggle();
            return;
        }

        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEventTypeEvent')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    updateAllRecurringEvents: updateAllRecurringEvents,
                    forceUpdate: forceUpdate,
                    function: 'updateEventTypeEvent'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })
            // if (checkDate >= today) {
            let obj = {
                updateAllRecurringEvents: updateAllRecurringEvents ?? false,
                eventId: eventId,
                allActiveForms: data.allActiveForms && data.type !== 'event' ? data.allActiveForms : false,
                eventForms: data.eventForms ? data.eventForms : [],
                type: 'event',
                startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                title: data.title,
                titleDoctor: data.titleDoctor,
                doctor: doctorId,
                colleagues: data.colleagues,
                forceUpdate: forceUpdate,
            };
            this.setState({
                loading: true,
                errorOverlap: null
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/event/update', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result?.errorOverlap) {
                        this.setState({
                            errorOverlap: {
                                data: data,
                                updateAllRecurringEvents: updateAllRecurringEvents
                            },
                            loading: false
                        })
                    } else if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false,
                            creatingEvent: false
                        })
                    } else {
                        this.setState({
                            loading: false,
                            creatingEvent: false
                        }, () => {
                            if (this.props.addToUpdatedEvents) {
                                this.props.addToUpdatedEvents([eventId]);
                            }
                            this.toggle(true)
                        })
                    }


                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })
        // }

    }

    updateEvent = (data) => {
        const eventId = data?._id ?? data?.id ?? null;
        const doctorId = this.state.doctorId ?? data?.doctor ?? null;
        if (!eventId || !doctorId) {
            this.setState({
                creatingEvent: false
            })
            this.toggle();
            return;
        }
        if (data.type === 'event') {

            if (data?.recurringKey) {
                this.setState({ updateEventModal: { ...data } })
            } else {
                this.updateEventTypeEvent(data, false)
            }

            return;
        }

        if (data && data.additionalDoctors && data.additionalDoctors.length) {
            this.checkDoctorsAvailable(data, 4, () => {
                if (!this.state.errorAdditionalDoctors) {
                    let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
                    let today = new Date();

                    if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEvent')) {
                        this.setState({
                            wrongDateModal: {
                                data: data,
                                function: 'updateEvent'
                            }
                        }, () => {
                            return;
                        })
                    } else {
                        this.setState({
                            wrongDateModal: null
                        })

                        // if (checkDate >= today) {
                        this.setState({
                            loading: true
                        }, () => {

                            fetch(API_ENDPOINT + '/working-hours/update/' + eventId, {
                                method: 'POST',
                                headers: {
                                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                    'content-type': 'application/json'
                                },
                                body: JSON.stringify({
                                    allActiveForms: data.allActiveForms ? data.allActiveForms : false,
                                    eventForms: data.eventForms ? data.eventForms : [],
                                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    title: data.title,
                                    titleDoctor: data.titleDoctor,
                                    doctor: doctorId,
                                    patientNote: data.patientNote,
                                    patientControlNote: data.patientControlNote,
                                    additionalDoctors: data.additionalDoctors,
                                    closeCaseManually: data.closeCaseManually,
                                    guests: data.guests,
                                    colleagues: data.colleagues,
                                    wrongDate: checkDate >= today
                                })
                            }).then(res => res.json()).then((result) => {
                                if (result.error) {
                                    this.setState({
                                        error: result.error.translate(this.props.lang),
                                        loading: false,
                                        creatingEvent: false
                                    })
                                } else {

                                    this.setState({
                                        loading: false,
                                        creatingEvent: false
                                    }, () => {
                                        if (this.props.addToUpdatedEvents) {
                                            this.props.addToUpdatedEvents([eventId]);
                                        }
                                        this.toggle(true)
                                    })
                                }

                            })
                        })
                    }
                    // } else {
                    //     this.setState({
                    //         wrongDate: true,
                    //         creatingEvent: false
                    //     })


                    // }
                } else {
                    this.setState({
                        creatingEvent: false
                    })
                }

            })
        } else {
            let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
            let today = new Date();

            if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEvent')) {
                this.setState({
                    wrongDateModal: {
                        data: data,
                        function: 'updateEvent'
                    }
                }, () => {
                    return;
                })
            } else {
                this.setState({
                    wrongDateModal: null
                })

                // if (checkDate >= today) {
                this.setState({
                    loading: true
                }, () => {

                    fetch(API_ENDPOINT + '/working-hours/update/' + eventId, {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            allActiveForms: data.allActiveForms && data.type !== 'event' ? data.allActiveForms : false,
                            eventForms: data.eventForms ? data.eventForms : [],
                            type: data.type,
                            startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                            endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            title: data.title,
                            titleDoctor: data.titleDoctor,
                            doctor: doctorId,
                            patientNote: data.patientNote,
                            patientControlNote: data.patientControlNote,
                            additionalDoctors: data.additionalDoctors,
                            closeCaseManually: data.closeCaseManually,
                            guests: data.guests,
                            colleagues: data.colleagues,
                            wrongDate: checkDate >= today
                        })
                    }).then(res => res.json()).then((result) => {
                        if (result.error) {
                            this.setState({
                                error: result.error.translate(this.props.lang),
                                loading: false,
                                creatingEvent: false
                            })
                        } else {

                            this.setState({
                                loading: false,
                                creatingEvent: false
                            }, () => {
                                if (this.props.addToUpdatedEvents) {
                                    this.props.addToUpdatedEvents([eventId]);
                                }
                                this.toggle(true)
                            })
                        }

                    })
                })
            }
            // } else {
            //     this.setState({
            //         wrongDate: true,
            //         creatingEvent: false
            //     })


            // }
        }


    }
    scheduleEvent = (data, forceInsert = false) => {
        if (!this.state.doctorId) {
            return;
        }
        let _data = JSON.parse(JSON.stringify(data));

        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }
        let checkDate = new Date(date?.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }
        if (checkDate >= today) {
            this.setState({
                loadingScheduleEvent: true,
                errorOverlap: false
            }, () => {
                let obj = {
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    doctor: this.state.doctorId,
                    title: data.title,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    recurring: data.recurring,
                    recurringObj: data.recurringObj,
                    title: data.title ? data.title : 'Event',
                    colleagues: data.colleagues,
                    forceInsert: forceInsert,
                };

                fetch(API_ENDPOINT + '/working-hours/new', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result.errorOverlap) {
                        this.setState({
                            errorOverlap: {
                                _data: _data
                            },
                            loadingScheduleEvent: false,
                            creatingEvent: false
                        })
                    } else if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loadingScheduleEvent: false,
                            creatingEvent: false
                        })
                    } else {
                        this.setState({
                            loadingScheduleEvent: false,
                            creatingEvent: false
                        }, () => {
                            this.toggle(true);
                        })
                    }

                })
            })
        } else {
            this.setState({
                wrongDate: true,
                creatingEvent: false
            })
        }


    }
    leaveCase = (data) => {
        this.setState({ leaveCaseModal: null })
        let additionalDoctors = [];
        if (data?.additionalDoctors && data?.additionalDoctors?.length) {
            for (let i = 0; i < data.additionalDoctors.length; i++) {
                if (data.additionalDoctors[i] != this.state.doctorId)
                    additionalDoctors.push(data.additionalDoctors[i])
            }
        }
        const eventId = data?._id ?? data?.id ?? null;
        if (!eventId) return;


        fetch(API_ENDPOINT + '/working-hours/update/' + eventId, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ additionalDoctors: additionalDoctors, updateOnlyAD: true })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang),
                    loading: false
                })
            } else {
                this.setState({
                    loading: false,
                }, () => {
                    this.toggle(true);
                })
            }

        })
    }
    closeReferral = (data, action = false) => {
        const closeCaseActionModal = {
            data: data ? JSON.parse(JSON.stringify(data)) : null,
            function: 'closeReferral'
        }
        if (!data) data = {};
        data.selectedGroup = this.props.selectedGroup;
        data.closeConversation = true;
        data.action = action;

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/close/' + this.state.previewReferral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.eventExits && result?.neededAction) {
                    this.setState({
                        closeCaseActionModal: closeCaseActionModal,
                        loading: false
                    })
                    return;
                }
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        previewReferral: null,
                        openPreviewReferral: false,

                    }, () => {
                        this.toggle(true);
                    })
                }

            })
        })
    }
    deleteReferral = () => {
        if (!this.state.previewReferral?._id) {
            return;
        }
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/delete/' + this.state.previewReferral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(res => res.json()).then((result) => {
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        previewReferral: null,
                        openPreviewReferral: false,
                    }, () => {
                        this.toggle(true);
                    })
                }

            })
        })
    }
    getAdditionalDoctorsNames = () => {
        let namesArr = [];
        let additionalDoctors = this.state.data?.additionalDoctors ?? null;
        let doctors = this.state.doctors ?? null;
        let doctorsDict = {};
        if (doctors && doctors.length) {
            for (let i = 0; i < doctors.length; i++) {
                if (doctors[i]?._id) {
                    doctorsDict[doctors[i]._id] = doctors[i];
                }
            }
        }
        if (additionalDoctors && additionalDoctors.length) {
            for (let i = 0; i < additionalDoctors.length; i++) {
                if (doctorsDict[additionalDoctors[i]]) {
                    namesArr.push(doctorsDict[additionalDoctors[i]]?.name);
                }
            }
        }
        let names = '';
        if (namesArr && namesArr.length) {
            names = namesArr.join(', ');
        }

        return names;
    }
    getParentsName = () => {
        let parents = this.state.data?.referral?.patient?.parents ?? null;
        let parentsArr = [];
        if (parents?.length) {
            for (let i = 0; i < parents.length; i++) {
                if (parents[i]?.name) {
                    parentsArr.push(parents[i].name);
                }
            }
        }
        let names = '';
        if (parentsArr?.length) {
            names = parentsArr.join(', ');
        }
        return names;
    }
    checkPatientNotes = () => {
        const { data } = this.state;
        let patientId, patientSSN, eventId, referralId;
        if (data) {
            if (data?.patientId) patientId = data.patientId;
            if (data?.patientProfile?.socialSecurityNumber) patientSSN = data.patientProfile.socialSecurityNumber;
            if (data?._id) eventId = data._id;
        }
        if (!patientId && !patientSSN && !eventId && !referralId) {
            this.setState({ patientNotes: [] })

            return;
        }
        let obj = {
            patientId,
            patientSSN,
            eventId,
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };

        this.setState({ patientNotes: [] }, () => {
            fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    this.setState({ patientNotes: result.items });
                }
            })
        })

    }
    disableTransferIfTimeIsOutOfWorkingHours = () => {
        let transferModal = this.state.transferModal;
        let startTimeSplit = transferModal.startTime.split(":");
        let endTimeSplit = transferModal.endTime.split(":");

        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

        const { minTransferDoctor, maxTransferDoctor } = this.state;
        const minTransferDoctorHourMinute = Number(minTransferDoctor?.split(":")?.[0]) * 60 + Number(minTransferDoctor?.split(":")?.[1]);
        const maxTransferDoctorHourMinute = Number(maxTransferDoctor?.split(":")?.[0]) * 60 + Number(maxTransferDoctor?.split(":")?.[1]);

        if (startTimeHourMinute > maxTransferDoctorHourMinute || endTimeHourMinute > maxTransferDoctorHourMinute) {
            if (startTimeHourMinute > maxTransferDoctorHourMinute) {
                transferModal.startTime = addMinutesToTime(maxTransferDoctor, -10);
                transferModal.endTime = maxTransferDoctor;

                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + minTransferDoctor + ' - ' + maxTransferDoctor
                    })

            }
            return true

        }
        if (startTimeHourMinute < minTransferDoctorHourMinute || endTimeHourMinute < minTransferDoctorHourMinute) {
            if (startTimeHourMinute < minTransferDoctorHourMinute) {
                transferModal.startTime = minTransferDoctor;
                transferModal.endTime = addMinutesToTime(minTransferDoctor, 10);
                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + minTransferDoctor + ' - ' + maxTransferDoctor
                    })
            }
            return true
        }

        this.setState({
            timeErrorMessage: null
        })
        return false
    }
    transferEvent = (data) => {
        const eventId = data?._id ?? data?.id ?? null;
        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {

                fetch(API_ENDPOINT + '/referrals/transfer/' + eventId, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        title: data.title,
                        titleDoctor: data.titleDoctor,
                        doctor: data.doctor,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic,
                        allActiveForms: data.allActiveForms,
                        eventForms: data.eventForms
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        this.setState({
                            transferModal: null,
                            timeErrorMessage: null,
                        })
                        if (this.props.addToUpdatedEvents) {
                            this.props.addToUpdatedEvents([eventId]);
                        }
                        this.toggle(true)
                    }

                })
            })
        } else {
            this.setState({
                wrongDate: true
            })


        }
    }
    doctorCheckedEventFroPatient = (checkIn) => {
        let checkDate = new Date(this.state.data?.date.replace(/-/g, "/") + ' ' + this.state.data?.startTime);
        let today = new Date();

        if (checkDate >= today || this.state.wrongDateCheckInModal) {
            const eventId = this.state.data?.id ?? this.state.data?._id;
            fetch(API_ENDPOINT + '/working-hours/doctor-check-in', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ eventId: eventId, checkIn: checkIn })
            }).then(res => res.json()).then((result) => {
                this.setState({
                    wrongDateCheckInModal: null
                })
                this.toggle(true)

            })
        } else {
            this.setState({
                wrongDateCheckInModal: checkIn ? 'yes' : 'no'
            })
        }
    }

    render() {
        const journalCuroflowEnable = checkIsJournalEnabled(this.props);

        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.getGroupData();

        const visitTemplates = groupData?.visitTemplates ?? null;
        const availabilityTemplatesEnabled = this.state.availabilityTemplates?.length && visitTemplates ? true : false;

        const enterprise = groupData?.enterprise ?? false;
        const eventMeetings = groupData?.eventMeetings ?? false;
        const availabilityInformationToClinicians = groupData?.bookingSettings?.availabilityInformationToClinicians ?? null;

        const doctorId = this.state.doctorId ?? null;

        const caseNumber = this.state.data?.referral?.patient?.referralNumber;

        const disabledSaveButton = !this.state.loading && doctorId && this.state.data && this.state.data.type &&
            (this.state.data?.type !== 'template' || (this.state.data?.type === 'template' && this.state.data?.selectedAvailabilityTemplate?.id))
            && (!this.state.data.frequencyType || (this.state.data.frequencyType &&
                (this.state.data.frequencyType == 'day' && this.state.data.frequencyDayText && this.state.data.frequencyDayScheduledDateFrom && this.state.data.frequencyDayScheduledDateTo)
                || (this.state.data.frequencyType == 'month' && this.state.data.frequencyMonthScheduled && this.state.data.frequencyMonthScheduledDateFrom && this.state.data.frequencyMonthScheduledDateTo)
                || (this.state.data.frequencyType == 'week' && (this.state.data.checkedMonday || this.state.data.checkedTuesday || this.state.data.checkedThursday || this.state.data.checkedWednesday || this.state.data.checkedFriday || this.state.data.checkedSaturday || this.state.data.checkedSunday) && this.state.data.frequencyWeekScheduledDateFrom && this.state.data.frequencyWeekScheduledDateTo)
            )) && !this.state.creatingEvent
            ? false : true;

        let _showStatusHistoryButton = null;
        if (this.state.previewReferral) {
            const showButton = showStatusHistoryButton(this.state.previewReferral);
            if (showButton) _showStatusHistoryButton = this.state.previewReferral;
        }

        const { minTime, maxTime, minTransferDoctor, maxTransferDoctor } = this.state;

        return (
            <>

                <Modal
                    isOpen={isOpen}
                    // size={this.state.data.patientProfile ? 'lg' : ''}
                    size={this.state.data.patientProfile ? _showStatusHistoryButton ? 'xl' : 'lg' : ''}
                    centered
                >
                    <ModalHeader
                        toggle={() => this.close()}
                        className='modal-header-flex'
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.close()}>&times;</button>}
                    >
                        <Label style={{ display: 'flex', gap: 10 }}>
                            <div>{'Update event'.translate(this.props.lang)}</div>
                            {
                                this.state.data?.isMarkedForCheckIn ?
                                    <div className='check-in-event'>
                                        <Isvg src={handled} width={20} height={20} />
                                        <div>{'Checked in'.translate(this.props.lang)}</div>
                                    </div>
                                    :
                                    null
                            }
                        </Label>
                        <div className='tooltip-title'>
                            {
                                this.state.data?.createOnWebDoc ?
                                    <Col lg='12'>
                                        <div className='flex-end mb-5'>
                                            <WebDocInfo lang={this.props.lang} bottomTooltip={true} />
                                        </div>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                this.state.data.patientProfile && !this.state.data.patientProfile?.phone && !this.state.data.patientProfile?.email ?
                                    <div className='patient-no-notif'>
                                        <Isvg src={noNotifications} width={20} height={20} />
                                        <div>
                                            {'Phone and email not registered'.translate(this.props.lang)}
                                        </div>
                                        <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </ModalHeader>

                    <ModalBody>
                        <Row>
                            <Col lg={this.state.data.patientProfile ? '6' : '12'}>
                                {this.state.data.type == 'referral' || this.state.data.type == 'revisit' ?
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input
                                            disabled
                                            type='textarea'
                                            value={this.state.data.titleDoctor && this.state.data.titleDoctor != '' ? this.state.data.baseTitle + ', ' + this.state.data.titleDoctor : this.state.data.title}
                                        />
                                        <Input
                                            type='text'
                                            style={{ marginTop: 5 }}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.titleDoctor = striptags(e.target.value);
                                                this.setState({
                                                    data
                                                })
                                            }}
                                            value={this.state.data.titleDoctor}
                                        />
                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input
                                            type='text'
                                            disabled={this.state.data?.isColleagueEvent}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.title = striptags(e.target.value);
                                                this.setState({
                                                    data
                                                })
                                            }}
                                            value={this.state.data.title}
                                        />
                                    </FormGroup>
                                }

                                <DatePicker
                                    label={'Start date'.translate(this.props.lang)}
                                    value={this.state.data.date}
                                    disabled={this.state.data?.isColleagueEvent}
                                    holidayEvents={this.state.holidayEvents}
                                    onChange={(e) => {
                                        let data = this.state.data;
                                        data.date = e;
                                        this.setState({
                                            data
                                        })
                                        if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                            data.endDate = this.state.data.date
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                                <Row>
                                    <Col
                                        xs={12}
                                        sm={eventMeetings && this.state.data?.type === 'event' && this.state.data?.meeting?._id && this.state.data?.meeting?.meetingHost?.length > 1 ? 4 : 12}
                                    >
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'Start time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                disabled={this.state.data?.isColleagueEvent}
                                                value={this.state.data.startTime}
                                                // minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                                // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                                minValue={minTime}
                                                maxValue={addMinutesToTime(maxTime, -5)}
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let data = this.state.data;
                                                    data.startTime = timeString

                                                    let startTimeSplit = data.startTime.split(":");
                                                    let endTimeSplit = data.endTime.split(":");

                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ data })
                                                    } else {
                                                        data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                                        const padded = data?.endTime?.split?.(':');
                                                        if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                            const h = padded[0]?.padStart?.(2, '0');
                                                            const m = padded[1]?.padStart?.(2, '0');
                                                            if (h && m) data.endTime = `${h}:${m}`;
                                                        }
                                                        this.setState({
                                                            data
                                                        })
                                                    }


                                                }}
                                            />

                                        </FormGroup>
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'End time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                disabled={this.state.data?.isColleagueEvent}
                                                value={this.state.data.endTime}
                                                minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                                // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')}
                                                maxValue={maxTime}
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let data = this.state.data;
                                                    data.endTime = timeString

                                                    let startTimeSplit = data.startTime.split(":");
                                                    let endTimeSplit = data.endTime.split(":");

                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ data })
                                                    }
                                                }}
                                            />

                                        </FormGroup>
                                    </Col>
                                    {eventMeetings && this.state.data?.type === 'event' && this.state.data?.meeting?._id && this.state.data?.meeting?.meetingHost?.length > 1 ? <Col
                                        xs={12}
                                        sm={8}
                                        className='event-meeting-participants-wrapper'
                                    >
                                        <button
                                            type='button'
                                            className={`event-meeting-participants-button ${this.state.meetingParticipants?.meetingId === this.state.data?.meeting?._id ? 'event-meeting-participants-button-expanded' : ''}`}
                                            onClick={() => {
                                                // console.log('this.state.data?.meeting: ', this.state.data?.meeting);

                                                if (this.state.meetingParticipants) return this.setState({
                                                    meetingParticipants: null
                                                });

                                                if (this.state.data?.meeting) {
                                                    const meeting = this.state.data?.meeting;

                                                    let hostId;
                                                    let participantIds = [];

                                                    if (meeting?.meetingHost && Array.isArray(meeting?.meetingHost) && meeting?.meetingHost.length) {
                                                        const newArr = [...new Set(meeting?.meetingHost)];
                                                        hostId = newArr[0];
                                                        if (newArr.length > 1) {
                                                            participantIds = newArr.slice(1);
                                                        }
                                                    }

                                                    let meetingParticipants = [];

                                                    if (hostId) {
                                                        const user = this.state.meetingParticipantsList.find(item => item._id === hostId);
                                                        if (!user) return;

                                                        meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)} <strong>(${'Organizer'.translate(this.props.lang)})</strong></span>`);
                                                    } else {
                                                        return;
                                                    }

                                                    if (participantIds?.length) {
                                                        for (const userId of participantIds) {
                                                            const user = this.state.meetingParticipantsList.find(item => item._id === userId);
                                                            if (!user) continue;

                                                            meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)}</span>`);
                                                        }
                                                    }

                                                    if (meetingParticipants?.length) {
                                                        this.setState({
                                                            meetingParticipants: {
                                                                meetingId: meeting._id,
                                                                list: meetingParticipants,
                                                            },
                                                        })
                                                    }
                                                }
                                            }}
                                        >
                                            <p>{'Meeting participants'.translate(this.props.lang)}</p>
                                            <span>&gt;</span>
                                        </button>
                                        {this.state.meetingParticipants?.meetingId === this.state.data?.meeting?._id ? <ul className='event-meeting-participants-list'>
                                            {this.state.meetingParticipants.list.map((item, index) => {
                                                return <li
                                                    key={index}
                                                >
                                                    <div dangerouslySetInnerHTML={{ __html: item }} />
                                                </li>
                                            })}
                                        </ul> : null}
                                    </Col> : null}
                                </Row>


                                {
                                    this.state.data?.doctorInfo?.name && !['event'].includes(this.state.data?.type) ?
                                        <FormGroup>
                                            <Label>{'Clinician'.translate(this.props.lang)}</Label>
                                            <Input
                                                disabled
                                                type='text'
                                                onChange={(e) => {
                                                }}
                                                value={this.state.data?._doctorInfo?.name ?? this.state.data.doctorInfo.name}
                                            />

                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.data?.additionalDoctors?.length ?
                                        <FormGroup>
                                            <Label>{'Added clinician'.translate(this.props.lang)}</Label>
                                            <Input
                                                disabled
                                                type='text'
                                                onChange={(e) => { }}
                                                value={this.getAdditionalDoctorsNames()}
                                            />

                                        </FormGroup>
                                        :
                                        null
                                }

                                {
                                    this.state.data.type == "referral" ?
                                        <FormGroup>
                                            <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                                <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                    <Isvg src={notesIcon} />
                                                    <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                </div>
                                            </Label>
                                            <Input type='textarea'
                                                name="note"
                                                style={{ height: '150px' }}
                                                onChange={(e) => {
                                                    let data = this.state.data;
                                                    data.patientNote = striptags(e.target.value);
                                                    this.setState({
                                                        data
                                                    })
                                                }}
                                                value={this.state.data.patientNote}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.data.type == 'revisit' ?
                                        <FormGroup>
                                            <Label className='note-label-wrap'>{this.state.data?.noteToPatient?.note ? 'Internal note'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}
                                                <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                    <Isvg src={notesIcon} />
                                                    <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                </div>
                                            </Label>
                                            <Input type='textarea'
                                                name="note"
                                                style={{ height: '150px' }}
                                                onChange={(e) => {
                                                    let data = this.state.data;
                                                    data.patientControlNote = striptags(e.target.value);
                                                    this.setState({
                                                        data
                                                    })
                                                }}
                                                value={this.state.data.patientControlNote}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.data?.noteToPatient?.note ?
                                        <>
                                            <FormGroup>
                                                <Label style={{ display: 'flex', alignItems: 'center' }}>
                                                    {'Note to patient'.translate(this.props.lang)}
                                                </Label>
                                                <Input
                                                    type='textarea'
                                                    name="noteToPatient"
                                                    style={{ height: '110px' }}
                                                    disabled={true}
                                                    onChange={(e) => {
                                                    }}
                                                    value={this.state.data.noteToPatient.note}
                                                />
                                            </FormGroup>
                                            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                <Checkbox
                                                    disabled={true}
                                                    checked={this.state.data?.noteToPatient?.sendNoteAsPatientNotification}
                                                    label={'Sent note as patient notification'.translate(this.props.lang)}
                                                />

                                            </FormGroup>
                                        </>
                                        :
                                        null
                                }
                                {
                                    this.state.data.type == 'revisit' && enterprise ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                disabled
                                                checked={this.state.data.hideTimeFromThePatient}
                                                label={'Hide time from the patient'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Time is not displayed to the patient.'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }

                                {
                                    this.state.data.type == 'revisit' || this.state.data.type == 'referral' /*&& enterprise*/ ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                disabled
                                                checked={this.state.data.hideDurationForPatient}
                                                label={'Hide duration for patient'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.data.type == 'revisit' && enterprise ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    let data = this.state.data;
                                                    data.closeCaseManually = e.target.checked;
                                                    this.setState({
                                                        data
                                                    })
                                                }}
                                                checked={this.state.data.closeCaseManually}
                                                label={'Close case manually'.translate(this.props.lang)}
                                            />

                                        </FormGroup>
                                        :
                                        null
                                }


                            </Col>

                            {
                                this.state.data.patientProfile ?
                                    <>
                                        <Col lg="6">
                                            <FormGroup>
                                                <Label>{'Case ID'.translate(this.props.lang)}</Label>
                                                <Input type='text' disabled
                                                    value={caseNumber} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Social security number'.translate(this.props.lang)} {this.state.data?._2fa ? <UserIsNotVerifiedTooltip warning lang={this.props.lang} /> : null}</Label>
                                                <Input type='text' disabled
                                                    value={this.state.data.patientProfile.socialSecurityNumber} />
                                            </FormGroup>
                                            {
                                                groupData?.patientInfoSettings?.isCustomIdEnabled ?
                                                    <FormGroup>
                                                        <Label>{groupData?.patientInfoSettings?.customIdLabel ? groupData?.patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled value={this.state.data.patientProfile?.customId ?? 'N/A'} />
                                                    </FormGroup>
                                                    :
                                                    null
                                            }
                                            <FormGroup>
                                                <Label>{'Name'.translate(this.props.lang)}</Label>
                                                <Input type='text' disabled
                                                    value={this.state.data.patientProfile.name} />
                                            </FormGroup>
                                            {
                                                this.state.data.patientProfile?.parents?.length ?
                                                    <FormGroup>
                                                        <Label>{'Parent/guardian'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.getParentsName()} />
                                                    </FormGroup>
                                                    :
                                                    null
                                            }
                                            <FormGroup>
                                                <Label>{'Email'.translate(this.props.lang)}</Label>
                                                <Input type='text' disabled
                                                    value={this.state.data.patientProfile.email} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Phone'.translate(this.props.lang)}</Label>
                                                <Input type='text' disabled
                                                    value={this.state.data.patientProfile.phone} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Address'.translate(this.props.lang)}</Label>
                                                <Input type='text' disabled
                                                    value={this.state.data.patientProfile.address} />
                                            </FormGroup>

                                            {
                                                this.state.previewReferral?._id ?
                                                    <EventPreviewPaymentField
                                                        {...this.props}
                                                        caseId={this.state.previewReferral._id}
                                                    />
                                                    :
                                                    null
                                            }
                                        </Col>
                                    </>
                                    :
                                    null
                            }
                            {
                                this.state.data?.type == 'event' ?
                                    <>
                                        <Col lg="12">

                                            {
                                                this.state.data?.isColleagueEvent ?
                                                    <div className='info-message-wrap'>
                                                        *{'You have been added as a colleague for this event. Only limited options are available for your access.'.translate(this.props.lang)}
                                                    </div>
                                                    :
                                                    null
                                            }

                                            {
                                                this.state.data?.recurringObj?.frequencyType ?
                                                    <RecurringDescription {...this.props} data={this.state.data} />
                                                    :
                                                    null
                                            }


                                        </Col>
                                        <Col lg="12" className='align-buttons-footer'>

                                            <div className='update-event-btns-wrap' style={{ marginBottom: 0 }}>
                                                {
                                                    eventMeetings ?
                                                        <>
                                                            {
                                                                this.state.data?.meeting?._id && this.state.data?.type === 'event' ?
                                                                    <FormGroup
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                        className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                const conversationId = this.state.data?.meeting?._id;
                                                                                this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Chat'.translate(this.props.lang)}
                                                                                {/* <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div> */}
                                                                            </div>
                                                                        </Button>
                                                                        {/* {
                                                                !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                    <div className='button-tooltip-wrap'>
                                                                        {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            } */}
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.state.data?.meeting?._id ?
                                                                    <FormGroup
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                        className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                if (this.state.data?.meeting?.active) {
                                                                                    const conversationId = this.state.data?.meeting?._id;
                                                                                    this.props.startVideoCall(conversationId)
                                                                                }
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Start video'.translate(this.props.lang)}
                                                                                <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                            </div>
                                                                        </Button>
                                                                        {
                                                                            !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                                <div className='button-tooltip-wrap'>
                                                                                    {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }



                                                        </>

                                                        :

                                                        null
                                                }
                                            </div>

                                            <div className='update-event-btns-wrap'>
                                                {
                                                    eventMeetings ?
                                                        <>
                                                            {
                                                                !this.state.data?.isColleagueEvent ?

                                                                    <FormGroup style={{ marginBottom: 0 }}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                let guests = [];
                                                                                if (this.state.data?.guests) {
                                                                                    guests = [...this.state.data.guests];
                                                                                }
                                                                                this.setState({
                                                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'updateEvent' }
                                                                                })
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {this.state.data?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                        </Button>
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }


                                                        </>

                                                        :

                                                        null
                                                }


                                                {
                                                    !this.state.data?.isColleagueEvent && !this.state.data.additionalDoctor ?
                                                        <Button
                                                            color='danger'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                let setObj = {
                                                                    warningModal: this.state.data,
                                                                    // data: !this.state.data,
                                                                    // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                                    // doctorsList: []
                                                                };
                                                                if (this.state.data?.type === 'event') {
                                                                    let deleteEventModal = { ...this.state.data };
                                                                    setObj.deleteEventModal = deleteEventModal;
                                                                    delete setObj.warningModal;
                                                                    this.setState(setObj)
                                                                } else {
                                                                    this.setState(setObj)
                                                                }
                                                            }}
                                                        >
                                                            {'Cancel time'.translate(this.props.lang)}
                                                        </Button>

                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data?.isColleagueEvent && this.state.data.type === 'event' && this.state.data?.doctor !== this.state.doctorId ?
                                                        <Button
                                                            color='danger'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                let setObj = {
                                                                    // data: !this.state.data,
                                                                    // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                                    // doctorsList: []
                                                                };
                                                                let deleteColleagueEventModal = { ...this.state.data };
                                                                setObj.deleteColleagueEventModal = deleteColleagueEventModal;
                                                                this.setState(setObj)
                                                            }}
                                                        >
                                                            {'Cancel time'.translate(this.props.lang)}
                                                        </Button>

                                                        :
                                                        null
                                                }


                                            </div>
                                            <div>

                                                <Button
                                                    color='primary'
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => this.close()}
                                                >
                                                    {'Close'.translate(this.props.lang)}
                                                </Button>

                                                {
                                                    !this.state.data?.isColleagueEvent && !this.state.data.additionalDoctor ?
                                                        <Button color='success' style={{ marginRight: 10 }} onClick={() => this.updateEvent(this.state.data)}>
                                                            {this.state.loading ?

                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Player
                                                                        onEvent={() => {
                                                                            if (!this.state.loading) this.stopAnimation();
                                                                        }}
                                                                        onStateChange={this.toggleVisibility}
                                                                        ref={this.player}
                                                                        autoplay={true}
                                                                        loop={true}
                                                                        controls={true}
                                                                        src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                        style={{ height: "20px", width: "30px" }}
                                                                    ></Player>
                                                                    {'Processing...'.translate(this.props.lang)}
                                                                </div>

                                                                : 'Save changes'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data?.isMarkedAsDone ?
                                                        <Button style={{ marginRight: 10 }} onClick={() => {
                                                            let data = this.state.data;
                                                            data.isMarkedAsDone = false
                                                            this.setState({
                                                                data
                                                            }, () => {
                                                                let eventId = this.state.data._id;
                                                                if (this.state.data?.type === 'event') {
                                                                    eventId = this.state.data._id.split('additional')[0];
                                                                }
                                                                this.props.updateEventIsDone(false, eventId, this.state.data.isMarkedAsDoneDoctor)
                                                            })
                                                        }} color='primary'>{'Mark as undone'.translate(this.props.lang)}</Button>
                                                        :
                                                        <Button style={{ marginRight: 10 }} onClick={() => {
                                                            let data = this.state.data;
                                                            data.isMarkedAsDone = true
                                                            this.setState({
                                                                data
                                                            }, () => {
                                                                let eventId = this.state.data._id;
                                                                if (this.state.data?.type === 'event') {
                                                                    eventId = this.state.data._id.split('additional')[0];
                                                                }
                                                                this.props.updateEventIsDone(true, eventId, this.state.data.isMarkedAsDoneDoctor)
                                                            })
                                                        }} color='primary'>{'Mark as done'.translate(this.props.lang)}</Button>
                                                }

                                            </div>


                                        </Col>
                                    </>
                                    :
                                    <>
                                        <Col lg="12">

                                            {
                                                this.state.data?.isColleagueEvent ?
                                                    <div className='info-message-wrap'>
                                                        *{'You have been added as a colleague for this event. Only limited options are available for your access.'.translate(this.props.lang)}
                                                    </div>
                                                    :
                                                    null
                                            }

                                            <div className='calendar-modal-buttons-wrap'>
                                                {
                                                    this.state.data.patientProfile && !this.state.data.additionalDoctor ?
                                                        <Button onClick={() => this.setState({
                                                            doctorsModal: 1
                                                        })} color="primary">
                                                            {'Add caregiver'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }

                                                {

                                                    this.state.data?.type !== 'free' && this.state.data?.type !== 'event' && eventMeetings ?
                                                        <>
                                                            {
                                                                !this.state.data?.isColleagueEvent ?

                                                                    <FormGroup style={{ marginBottom: 0 }}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                let guests = [];
                                                                                if (this.state.data?.guests) {
                                                                                    guests = [...this.state.data.guests];
                                                                                }
                                                                                this.setState({
                                                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'updateEvent' }
                                                                                })
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {this.state.data?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                        </Button>
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.state.data?.meeting?._id ?
                                                                    <FormGroup style={{ marginBottom: this.state.data?.isColleagueEvent ? 10 : 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                if (this.state.data?.meeting?.active) {
                                                                                    const conversationId = this.state.data?.meeting?._id;
                                                                                    this.props.startVideoCall(conversationId)
                                                                                }
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Start video'.translate(this.props.lang)}
                                                                                <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                            </div>
                                                                        </Button>
                                                                        {
                                                                            !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                                <div className='button-tooltip-wrap'>
                                                                                    {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.state.data?.meeting?._id && this.state.data?.type === 'event' ?
                                                                    <FormGroup
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                        className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                const conversationId = this.state.data?.meeting?._id;
                                                                                this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Chat'.translate(this.props.lang)}
                                                                                {/* <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div> */}
                                                                            </div>
                                                                        </Button>
                                                                        {/* {
                                                                !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                    <div className='button-tooltip-wrap'>
                                                                        {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            } */}
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                        </>

                                                        :

                                                        null
                                                }

                                            </div></Col>
                                        <Col lg="12" className='align-buttons-footer'>

                                            <div className='update-event-btns-wrap'>
                                                {
                                                    !this.state.data?.isColleagueEvent && this.state.data.patientProfile && (!this.state.data.additionalDoctors || (this.state.data.additionalDoctors && !this.state.data.additionalDoctors.filter(item => item == this.state.doctorId).length)) ?
                                                        <Button color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                this.openConversation(this.state.data)

                                                            }}
                                                        >
                                                            {'Open conversation'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data.patientProfile && this.state.data.additionalDoctors && this.state.data.additionalDoctors.filter(item => item == this.state.doctorId).length ?
                                                        <Button color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                this.openConversation(this.state.data)
                                                            }}
                                                        >
                                                            {'Open conversation'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data.patientProfile && this.state.offerData && this.state.startedVideoCallConversation && this.state.data.additionalDoctors && this.state.data.additionalDoctors.filter(item => item == this.state.doctorId).length ?
                                                        <Button
                                                            color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                this.answerCall(this.state.offerData[this.state.startedVideoCallConversation])
                                                            }}
                                                        >
                                                            {'Join video call'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.data?.meeting?._id && !this.state.data?.isColleagueEvent && this.state.data.patientProfile && (!this.state.data.additionalDoctors || (this.state.data.additionalDoctors && !this.state.data.additionalDoctors.filter(item => item == this.state.doctorId).length)) ?
                                                        <div className='start-video-call-btn-wrap calendar-video-start-tooltip'>
                                                            <button className={this.state.waitingRoom?.patientId === this.state.data?.patientProfile?._id && this.state.waitingRoom?.showInfoWaitingRoom ? 'start-video-btn patient-waiting-room' : 'start-video-btn'} style={{ padding: 6, paddingLeft: 12, paddingRight: 12, height: 'auto' }} onClick={() => {
                                                                this.startVideoCall(this.state.data)
                                                            }}>
                                                                <div className="quick-phrase-tooltip-on">
                                                                    {'Start video chat'.translate(this.props.lang)}
                                                                    <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                </div>
                                                            </button>

                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.data?.isColleagueEvent && this.state.data.additionalDoctors && this.state.data.additionalDoctors.filter(item => item == this.state.doctorId).length ?
                                                        <Button color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                this.setState({ leaveCaseModal: this.state.data })
                                                            }}>
                                                            {'Leave case'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.data?.isColleagueEvent && !this.state.data.additionalDoctor ?
                                                        <Button color='primary'
                                                            style={{

                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    transferModal: JSON.parse(JSON.stringify(this.state.data)),
                                                                    // updateEvent: !this.state.updateEvent,
                                                                    // meetingParticipants: null,
                                                                    // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                                    // doctorsList: []
                                                                })

                                                            }}
                                                        >
                                                            {'Transfer'.translate(this.props.lang)}</Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.data?.isColleagueEvent && !this.state.data.additionalDoctor ?
                                                        <Button
                                                            color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                const caseId = this.state.previewReferral?._id;
                                                                if (caseId) {
                                                                    this.setState({ cancelVisitModal: caseId })
                                                                    return;
                                                                }

                                                                let setObj = {
                                                                    warningModal: this.state.data,
                                                                    // data: !this.state.data,
                                                                    // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                                    // doctorsList: []
                                                                };
                                                                if (this.state.data?.type === 'event') {
                                                                    let deleteEventModal = { ...this.state.data };
                                                                    setObj.deleteEventModal = deleteEventModal;
                                                                    delete setObj.warningModal;
                                                                    this.setState(setObj)
                                                                } else {
                                                                    this.setState(setObj)
                                                                }
                                                            }}
                                                        >
                                                            {'Cancel time'.translate(this.props.lang)}
                                                        </Button>

                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data?.isColleagueEvent && this.state.data.type === 'event' && this.state.data?.doctor !== this.state.doctorId ?
                                                        <Button
                                                            color='primary'
                                                            style={{
                                                            }}
                                                            onClick={() => {
                                                                let setObj = {
                                                                    // data: !this.state.data,
                                                                    // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                                    // doctorsList: []
                                                                };
                                                                let deleteColleagueEventModal = { ...this.state.data };
                                                                setObj.deleteColleagueEventModal = deleteColleagueEventModal;
                                                                this.setState(setObj)
                                                            }}
                                                        >
                                                            {'Cancel time'.translate(this.props.lang)}
                                                        </Button>

                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data?.type !== 'free' && this.state.data?.type === 'event' && eventMeetings ?
                                                        <>
                                                            {
                                                                !this.state.data?.isColleagueEvent ?

                                                                    <FormGroup style={{ marginBottom: 0 }}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                let guests = [];
                                                                                if (this.state.data?.guests) {
                                                                                    guests = [...this.state.data.guests];
                                                                                }
                                                                                this.setState({
                                                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'updateEvent' }
                                                                                })
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {this.state.data?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                        </Button>
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.state.data?.meeting?._id ?
                                                                    <FormGroup
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                        className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                if (this.state.data?.meeting?.active) {
                                                                                    const conversationId = this.state.data?.meeting?._id;
                                                                                    this.props.startVideoCall(conversationId)
                                                                                }
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Start video'.translate(this.props.lang)}
                                                                                <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                            </div>
                                                                        </Button>
                                                                        {
                                                                            !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                                <div className='button-tooltip-wrap'>
                                                                                    {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.state.data?.meeting?._id && this.state.data?.type === 'event' ?
                                                                    <FormGroup
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                        className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                        <Button
                                                                            disabled={!this.state.data?.meeting?.active}
                                                                            onClick={() => {
                                                                                const conversationId = this.state.data?.meeting?._id;
                                                                                this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            <div className="quick-phrase-tooltip-on">
                                                                                {'Chat'.translate(this.props.lang)}
                                                                                {/* <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div> */}
                                                                            </div>
                                                                        </Button>
                                                                        {/* {
                                                                !this.state.data?.meeting?.active && this.state.data?.meeting?.message ?
                                                                    <div className='button-tooltip-wrap'>
                                                                        {this.state.data.meeting.message?.translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            } */}
                                                                    </FormGroup>
                                                                    :
                                                                    null
                                                            }


                                                        </>

                                                        :

                                                        null
                                                }

                                                {
                                                    !this.state.data?.isColleagueEvent && this.state.previewReferral ?
                                                        <Button color='primary'
                                                            style={{}}
                                                            onClick={() => this.setState({ openPreviewReferral: true })}
                                                        >
                                                            {'Case preview'.translate(this.props.lang)}
                                                        </Button>

                                                        :
                                                        null
                                                }
                                                {
                                                    _showStatusHistoryButton ? <Button
                                                        color='primary'
                                                        style={{ padding: 6, paddingLeft: 12, paddingRight: 12 }}
                                                        onClick={() => {
                                                            this.setState({ statusHistoryModal: _showStatusHistoryButton })
                                                        }}
                                                    >
                                                        {'View history'.translate(this.props.lang)}
                                                    </Button> : null
                                                }
                                                {
                                                    this.state.previewReferral?.journalNote ?
                                                        <Button
                                                            color='primary'
                                                            onClick={() => this.setState({ previewJournalNote: this.state.previewReferral?.journalNote })}
                                                        >
                                                            {'Journal note'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                            </div>
                                            <div>

                                                <Button
                                                    color='danger'
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => this.close()}
                                                >
                                                    {'Cancel'.translate(this.props.lang)}
                                                </Button>

                                                {
                                                    !this.state.data?.isColleagueEvent && !this.state.data.additionalDoctor ?
                                                        <Button color='success' style={{ marginRight: 10 }} onClick={() => this.updateEvent(this.state.data)}>
                                                            {this.state.loading ?

                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Player
                                                                        onEvent={() => {
                                                                            if (!this.state.loading) this.stopAnimation();
                                                                        }}
                                                                        onStateChange={this.toggleVisibility}
                                                                        ref={this.player}
                                                                        autoplay={true}
                                                                        loop={true}
                                                                        controls={true}
                                                                        src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                        style={{ height: "20px", width: "30px" }}
                                                                    ></Player>
                                                                    {'Processing...'.translate(this.props.lang)}
                                                                </div>

                                                                : 'Save changes'.translate(this.props.lang)}
                                                        </Button>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.state.data?.isMarkedAsDone ?
                                                        <Button style={{ marginRight: 10 }} onClick={() => {
                                                            let data = this.state.data;
                                                            data.isMarkedAsDone = false
                                                            this.setState({
                                                                data
                                                            }, () => {
                                                                let eventId = this.state.data._id;
                                                                if (this.state.data?.type === 'event') {
                                                                    eventId = this.state.data._id.split('additional')[0];
                                                                }
                                                                this.props.updateEventIsDone(false, eventId, this.state.data.doctor)
                                                            })
                                                        }} color='primary'>{'Mark as undone'.translate(this.props.lang)}</Button>
                                                        :
                                                        <Button style={{ marginRight: 10 }} onClick={() => {
                                                            let data = this.state.data;
                                                            data.isMarkedAsDone = true
                                                            this.setState({
                                                                data
                                                            }, () => {
                                                                let eventId = this.state.data._id;
                                                                if (this.state.data?.type === 'event') {
                                                                    eventId = this.state.data._id.split('additional')[0];
                                                                }
                                                                this.props.updateEventIsDone(true, eventId, this.state.data.doctor)
                                                            })
                                                        }} color='primary'>{'Mark as done'.translate(this.props.lang)}</Button>
                                                }
                                                {journalCuroflowEnable ?
                                                    this.state.data?.isMarkedForCheckIn ?
                                                        <Button color='primary' style={{ marginRight: 10 }} onClick={() => this.doctorCheckedEventFroPatient(false)}>{"Cancel check in".translate(this.props.lang)}</Button>
                                                        :
                                                        <Button color='primary' style={{ marginRight: 10 }} onClick={() => this.doctorCheckedEventFroPatient(true)}>{"Check in".translate(this.props.lang)}</Button>
                                                    :
                                                    null
                                                }
                                            </div>


                                        </Col>

                                    </>
                            }

                            <Col lg='12' style={{ marginTop: 15 }}>

                                {
                                    this.state.data?.type === 'event' || true ?
                                        this.state.data?.tsCreated && this.state.data?.tsModified && this.state.data?.tsCreated !== this.state.data?.tsModified ?
                                            <div className='info-message-update-wrap'>
                                                {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                            </div>
                                            :
                                            this.state.data?.tsCreated ?
                                                <div className='info-message-update-wrap'>
                                                    {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                                </div>
                                                :
                                                null
                                        :
                                        null

                                }</Col>

                        </Row>
                    </ModalBody>
                </Modal>
                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }

                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.changesNotSaved ?
                        <Modal isOpen={this.state.changesNotSaved} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{'Some changes are not saved.'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color="primary"
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.setState({
                                            changesNotSaved: false
                                        }, () => {
                                            this.updateEvent(this.state.data)
                                        })
                                    }}
                                >
                                    {'Save and exit'.translate(this.props.lang)}
                                </Button>


                                <Button
                                    color="primary"
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.toggle();
                                    }}
                                >
                                    {'Exit without saving'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal
                            isOpen={this.state.doctorsModal}
                            centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })}
                        >
                            <ModalHeader
                                toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.state.doctorId && item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (this.state.doctorId && item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent
                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el => !this.state.data || (this.state.data && this.state.data.patientId != el._id)).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.state.doctorId && item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {
                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                if (data && modal) {
                                    if (modal === 'updateEvent') {
                                        setObj.data = { ...this.state.data, guests: data };
                                        if (this.state.data?.type === 'event') {
                                            setObj.data = { ...this.state.data, colleagues: data };
                                        } else {
                                            setObj.data = { ...this.state.data, guests: data };
                                        }
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {

                    this.state.deleteColleagueEventModal && !this.state.deleteColleagueEventModal.recurringKey ?
                        <Modal isOpen={this.state.deleteColleagueEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to leave this event meeting?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id ?? this.state.deleteColleagueEventModal?._id;
                                        const colleagueId = this.state.doctorId;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, false)
                                        }
                                    }}
                                >
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteColleagueEventModal: !this.state.deleteColleagueEventModal })}>
                                    {'No'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }
                {
                    this.state.previewJournalNote ?
                        <Modal isOpen={this.state.previewJournalNote} centered>
                            <ModalHeader toggle={() => this.setState({ previewJournalNote: null })}>{'Journal note'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>
                                <div className="journal-note-preview-calendar-wrap">
                                    {
                                        this.state.previewJournalNote.map((note, i) => {
                                            return (
                                                <div className='journal-note-preview-item-wrap'>
                                                    <h6>{note?.title?.translate(this.props.lang)}</h6>
                                                    <p>{note?.content}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }} className='buttons-right-blue'>
                                <Button color='primary'
                                    onClick={() => {
                                        let text = '';
                                        for (let i = 0; i < this.state.previewJournalNote?.length; i++) {
                                            text += `${this.state.previewJournalNote[i]?.title?.translate(this.props.lang)}\n${this.state.previewJournalNote[i]?.content}`;
                                            if (i !== this.state.previewJournalNote.length - 1) {
                                                text += '\n\n';
                                            }

                                        }
                                        this.setState({ textCopied: true }, () => {
                                            if (this.copyTimeout) {
                                                clearTimeout(this.copyTimeout)
                                            }
                                            this.copyTimeout = setTimeout(() => {
                                                this.setState({ textCopied: false })
                                            }, 1200)
                                        })

                                        navigator.clipboard.writeText(text)

                                    }}
                                >
                                    {this.state.textCopied ? 'Text copied'.translate(this.props.lang) : 'Copy text'.translate(this.props.lang)}
                                </Button>
                                <Button color="primary" onClick={() => this.setState({ previewJournalNote: null })}> {'Close'.translate(this.props.lang)} </Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {

                    this.state.deleteEventModal?.recurringKey ?
                        <Modal isOpen={this.state.deleteEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to delete this event, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id ?? this.state.deleteEventModal?._id ?? null;

                                        this.deleteEventTypeEvent(eventId, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id ?? this.state.deleteEventModal?._id ?? null;
                                        this.deleteEventTypeEvent(eventId, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventModal: !this.state.deleteEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteEventModal && !this.state.deleteEventModal.recurringKey ?
                        <Modal isOpen={this.state.deleteEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to delete this event?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id ?? this.state.deleteEventModal?._id ?? null;

                                        this.deleteEventTypeEvent(eventId, false)
                                    }}
                                >
                                    {'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventModal: !this.state.deleteEventModal })}>
                                    {'Go back'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteColleagueEventModal?.recurringKey ?
                        <Modal isOpen={this.state.deleteColleagueEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to leave this event meeting, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id ?? this.state.deleteColleagueEventModal?._id ?? null;
                                        const colleagueId = this.state.doctorId;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, false)
                                        }
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id ?? this.state.deleteColleagueEventModal?._id ?? null;
                                        const colleagueId = this.state.doctorId;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, true)
                                        }

                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteColleagueEventModal: !this.state.deleteColleagueEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteColleagueEventModal && !this.state.deleteColleagueEventModal.recurringKey ?
                        <Modal isOpen={this.state.deleteColleagueEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to leave this event meeting?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id ?? this.state.deleteColleagueEventModal?._id ?? null;
                                        const colleagueId = this.state.doctorId;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, false)
                                        }
                                    }}
                                >
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteColleagueEventModal: !this.state.deleteColleagueEventModal })}>
                                    {'No'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.warningModal ?
                        <Modal isOpen={this.state.warningModal} centered >
                            <ModalBody className="delete-modal">
                                {this.state.warningModal.title == 'Free time'.translate(this.props.lang) ?
                                    <div className='message'>{'Do you really want to delete the scheduled time? In that case, do not forget to book a new one!'.translate(this.props.lang)}</div>
                                    :
                                    <div className='message'>{'Do you really want to delete the booked time? In that case, do not forget to book a new one!'.translate(this.props.lang)}</div>
                                }



                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.deleteEvent(this.state.warningModal)}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Cancel time'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ warningModal: !this.state.warningModal })}>{'Cancel'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {

                    this.state.updateEventModal ?
                        <Modal isOpen={this.state.updateEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to update this event, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loading}
                                    color='primary'
                                    onClick={() => {
                                        const data = { ...this.state.updateEventModal };
                                        this.updateEventTypeEvent(data, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loading}
                                    color='primary'
                                    onClick={() => {
                                        const data = { ...this.state.updateEventModal };
                                        this.updateEventTypeEvent(data, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ updateEventModal: !this.state.updateEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.errorOverlap ?
                        <Modal isOpen={this.state.errorOverlap} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>{'Bookings in your calendar already exist for the selected period'.translate(this.props.lang)}</div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading || this.state.loadingScheduleEvent}
                                    onClick={() => {
                                        const data = this.state.errorOverlap?.data;
                                        const _data = this.state.errorOverlap?._data;
                                        const updateAllRecurringEvents = this.state.errorOverlap?.updateAllRecurringEvents;
                                        if (data) {
                                            this.updateEventTypeEvent(data, updateAllRecurringEvents, true)
                                        } else if (_data) {
                                            this.scheduleEvent(_data, true)
                                        }
                                    }}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Continue anyways'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.setState({
                                        errorOverlap: !this.state.errorOverlap,
                                        updateEventModal: null

                                    })
                                }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.leaveCaseModal ?
                        <Modal isOpen={this.state.leaveCaseModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>
                                    {'Do you want to leave the case'.translate(this.props.lang)}
                                </div>



                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.leaveCase(this.state.data)}>
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ leaveCaseModal: !this.state.leaveCaseModal })}>{'No'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.previewAnswersModal ?
                        <Modal isOpen={this.state.previewAnswersModal} centered toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} size="lg">
                            <ModalHeader toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })}><Isvg src={xIcon} /></button>}>{'Form preview'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                <FormPreview
                                    {...this.props}
                                    referral={{
                                        _id: this.state.previewAnswersModal._id,
                                        name: this.state.previewAnswersModal.name,
                                        description: this.state.previewAnswersModal.description,
                                        intelligentReferral: this.state.previewAnswersModal.intelligentReferral,
                                        items: this.state.previewAnswersModal.items,
                                        group: groupData?._id
                                    }}
                                    sections={generateSections(this.state.previewAnswersModal.items)}
                                    answers={this.state.previewAnswersModal.answers}
                                    disabledForm={true}
                                    hidePreview={true}
                                >
                                </FormPreview>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred. When saving changes, no notifications will be sent out.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {

                                        if (this.state.wrongDateModal?.function === 'updateEvent') {
                                            this.updateEvent(this.state.wrongDateModal?.data)
                                        } else if (this.state.wrongDateModal?.function === 'updateEventTypeEvent') {
                                            this.updateEventTypeEvent(this.state.wrongDateModal?.data, this.state.wrongDateModal?.updateAllRecurringEvents, this.state.wrongDateModal?.forceUpdate)
                                        }
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        wrongDateModal: null,
                                        creatingEvent: null,
                                    })}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.wrongDateCheckInModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateCheckInModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateCheckInModal: null
                                })
                            }}
                            info={"This event has already occurred.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {

                                        if (this.state.wrongDateCheckInModal === 'yes') {
                                            this.doctorCheckedEventFroPatient(true)
                                        } else if (this.state.wrongDateCheckInModal === 'no') {
                                            this.doctorCheckedEventFroPatient(false)
                                        }
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        wrongDateCheckInModal: null,
                                    })}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.openPreviewReferral ?
                        <ReferralContent
                            {...this.props}
                            data={this.state.previewReferral}
                            screen={'my-cases'}
                            calendar={true}
                            doctorPage={true}
                            enterprise={enterprise}

                            closeCase={() => { this.setState({ closeCase: true }) }}
                            deleteCase={() => { this.setState({ deleteCase: true }) }}

                            previewAnswersRevisit={(form) => {
                                this.setState({ previewAnswersModal: form })
                            }}
                            closeReferralContent={(data) => {
                                if (this.state.openPreviewReferral) {
                                    this.setState({
                                        openPreviewReferral: null
                                    })
                                }
                            }}
                            setData={(data, refresh = false) => {
                                if (data) {
                                    let previewReferral = this.state.previewReferral;
                                    if (data && Object.keys(data)?.length) {
                                        for (var key in data) {
                                            previewReferral[key] = data[key];
                                        }
                                        this.setState({
                                            previewReferral: null,
                                            openPreviewReferral: false,
                                            updateEvent: null,
                                            offerData: null,
                                            prevUpdateEvent: null,
                                        }, () => {
                                            if (refresh) {
                                                this.toggle(true);
                                            }
                                        })
                                    }
                                }
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.closeCase ?
                        <Modal isOpen={this.state.closeCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to close the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false }, () => this.closeReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.deleteCase ?
                        <Modal isOpen={this.state.deleteCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to delete the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false }, () => this.deleteReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.closeCaseActionModal ?
                        <ErrorModalV2
                            isOpen={this.state.closeCaseActionModal}
                            modalFooterClassName={'modal-footer-buttons-wrap'}
                            buttons={[
                                {
                                    text: 'Close case and keep calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'keepCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Close case and delete calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'deleteCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Cancel'.translate(this.props.lang),
                                    onClick: () => {
                                        this.setState({ closeCaseActionModal: false })
                                    }
                                }
                            ]}
                        >
                            {'Do you also want to delete the calendar post?'.translate(this.props.lang)}
                        </ErrorModalV2>
                        :
                        null
                }



                {
                    this.state.transferModal ?
                        <Modal
                            isOpen={this.state.transferModal}
                            centered
                        >
                            <ModalHeader
                                toggle={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })}>&times;</button>}
                            >
                                {'Transfer event'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Doctors'.translate(this.props.lang)}</Label>
                                    <Input type='select'

                                        onChange={e => {
                                            let transferModal = this.state.transferModal;
                                            const doctorId = e.target.value == -1 ? null : e.target.value;
                                            transferModal.doctor = doctorId;
                                            this.setState({
                                                transferModal
                                            }, () => {
                                                // this.get();
                                                this.getTransferWorkingHours(doctorId, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours();
                                                });
                                            })

                                        }}
                                    >
                                        <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                        {this.state.doctors.filter(el => el._id != this.state.transferModal.patientId && el._id != this.state.data.doctor).sort((a, b) => {
                                            const nameA = a.name.toLowerCase();
                                            const nameB = b.name.toLowerCase();
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map(item => {
                                            let obj = {}
                                            obj.min = new Date()
                                            obj.min.setHours(7, 0, 0)
                                            obj.max = new Date()
                                            obj.max.setHours(18, 0, 0)
                                            if (item.workingTimeConfig) {

                                                if (item.workingTimeConfig[this.props.selectedGroup] && item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                                                    let minTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min
                                                    let maxTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max
                                                    obj.min = new Date();
                                                    obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                                                    obj.max = new Date();
                                                    obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)
                                                }
                                            } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {

                                                if (groupData?.bookingSettings) {
                                                    const bookingSettings = groupData.bookingSettings;

                                                    if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {

                                                        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min)?.getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max)?.getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                                    }

                                                }
                                            }

                                            if (item._id != this.state.doctor)
                                                return <option value={item._id}>
                                                    {item.userData && item.userData.title && item.userData.name ? this.props.formatName(item?.userData?.title, item?.userData?.name) : item.name} - {item.username}    ({this.props.getStringDateTs(Math.floor(obj?.min?.getTime() / 1000), 'HH:mm')} - {this.props.getStringDateTs(Math.floor(obj?.max?.getTime() / 1000), 'HH:mm')})
                                                </option>
                                        })}

                                    </Input>
                                </FormGroup>
                                {this.state.transferModal.type == 'referral' || this.state.transferModal.type == 'revisit' ?
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input disabled type='textarea'
                                            value={this.state.transferModal.titleDoctor && this.state.transferModal.titleDoctor != '' ? this.state.transferModal.baseTitle + ', ' + this.state.transferModal.titleDoctor : this.state.transferModal.title} />
                                        <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                            let transferModal = this.state.transferModal;
                                            transferModal.titleDoctor = striptags(e.target.value);

                                            this.setState({
                                                transferModal
                                            })
                                        }}
                                            value={this.state.transferModal.titleDoctor} />

                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input type='text'
                                            onChange={(e) => {
                                                let updateEvent = this.state.updateEvent;
                                                updateEvent.title = striptags(e.target.value);
                                                this.setState({
                                                    updateEvent
                                                })
                                            }}
                                            value={this.state.transferModal.title} />


                                    </FormGroup>
                                }
                                <DatePicker
                                    label={'Start date'.translate(this.props.lang)}
                                    value={this.state.transferModal.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let transferModal = this.state.transferModal;
                                        transferModal.date = e;
                                        this.setState({
                                            transferModal
                                        })
                                        if (Math.floor(new Date(this.state.transferModal.date + ' ' + this.state.transferModal.startTime) / 1000) > Math.floor(new Date(this.state.transferModal.endDate + ' ' + this.state.transferModal.endTime) / 1000)) {
                                            transferModal.endDate = this.state.transferModal.date
                                            this.setState({
                                                transferModal
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.startTime}
                                        minValue={minTransferDoctor}
                                        maxValue={addMinutesToTime(maxTransferDoctor, -5)}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.startTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            this.setState({ transferModal })

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            } else {
                                                transferModal.endTime = Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60
                                                const padded = transferModal?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) transferModal.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    transferModal
                                                }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            }
                                        }}
                                    />

                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.endTime}
                                        minValue={Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={maxTransferDoctor}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.endTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            } else {
                                                //this.setState({ wrongInput: true })
                                            }
                                        }}
                                    />
                                </FormGroup>
                                {
                                    this.state.timeErrorMessage ?
                                        <p style={{ color: 'red' }}>{this.state.timeErrorMessage}</p>
                                        :
                                        null
                                }


                                <Button
                                    color='primary'
                                    disabled={!this.state.timeErrorMessage && this.state.transferModal.doctor ? false : true}
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        this.transferEvent(this.state.transferModal)
                                    }}
                                >
                                    {'Transfer doctor'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10 }} onClick={() => this.setState({ transferModal: !this.state.transferModal })}>{'Cancel'.translate(this.props.lang)}</Button>

                            </ModalBody>
                        </Modal>
                        : null
                }
                {
                    this.state.cancelVisitModal ?
                        <VisitCancellation
                            {...this.props}
                            isOpen={this.state.cancelVisitModal}
                            onClose={(refetchData = false, closeUpdateEvent = false) => {
                                let setObj = { cancelVisitModal: null };
                                // if (closeUpdateEvent) {
                                //     setObj.updateEvent = null;
                                //     setObj.meetingParticipants = null;
                                //     setObj.prevUpdateEvent = null;
                                //     setObj.doctorsList = [];
                                //     setObj.offerData = null;
                                // }
                                this.setState(setObj, () => {
                                    if (refetchData) {
                                        this.toggle(true)
                                    }
                                })
                            }}
                            caseId={this.state.cancelVisitModal}
                        />
                        :
                        null
                }
            </>


        )
    }
}

export default UpdateEvent;